import './styles/reducedMotion.scss';

import { ApolloProvider } from '@apollo/client/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { HydrationMarker } from '@repo/ui/components/HydrationMarker';
import { AUTH_TRANSITION_KIND, publishAuthTransition } from '@repo/ui/contexts/auth-transition';

import { App } from './App';
import { RootErrorBoundary } from './components/root-error-boundary';
import { graphQLClient } from './graphql/client';
import i18n from './i18n/i18n';

const oauthParams = new URLSearchParams(window.location.search);
if (oauthParams.has('auth_success')) {
  oauthParams.delete('auth_success');
  const query = oauthParams.toString();
  window.history.replaceState({}, '', query ? `${window.location.pathname}?${query}` : window.location.pathname);
  graphQLClient.resetStore().catch(error => console.error('Failed to reset Apollo state after OAuth login', error));
  publishAuthTransition(AUTH_TRANSITION_KIND.SignedIn);
}

const rootElement = document.getElementById('root');

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <>
        <HydrationMarker />
        <App />
      </>
    ),
    ErrorBoundary: RootErrorBoundary,
  },
]);

if (!rootElement) {
  throw new Error('Failed to find the root element');
}

createRoot(rootElement).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <ApolloProvider client={graphQLClient}>
        <RouterProvider router={router} />
      </ApolloProvider>
    </I18nextProvider>
  </StrictMode>,
);
